import { apiRequest } from '../../services/apiClient';

export interface DirectOrderInput {
  portfolioId: string;
  quantity: number;
  company: string;
  name: string;
  password?: string;
  email: string;
  phone: string;
  content: string;
}

export interface DirectOrderResult {
  id: string;
  orderNo: string;
  totalPrice: number;
}

// 주문상품 바로결제: 결제 대기 주문을 만들고 주문번호를 받아 결제창으로 넘어간다
export function createDirectOrder(input: DirectOrderInput, token?: string): Promise<DirectOrderResult> {
  return apiRequest<DirectOrderResult>('/api/direct-orders', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(input),
  });
}
